import { useTranslation } from "react-i18next";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { Paper, Stack, Typography, useMediaQuery } from "@mui/material";
// import { INavigationItem } from "../../services/navigation-data-service/Models";
import { ContentView } from "../../components/content-view/ContentView";
import { ContentContainer } from "../../components/content-container/ContentContainer";
import { ContentSection } from "../../components/content-section/ContentSection";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import useAlarmDashboardState from "./AlarmDashboardState";
import OptionsSideSheet from "../../components/options-side-sheet/OptionsSideSheet";
import AlarmDashboardChartContainer from "./AlarmDashboardChartContainer";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { useCustomerAttribute } from "../../queries/attributes/UseCustomerAttribute";
import { NotificationsCountChart } from "../../components/dashboard/alarm-notifications/notifications-count-chart/NotificationsCountChart";
import { AlarmNotificationsType } from "../../services/alarm-data-service/Models";
import { NotificationsCountsGraph } from "../../components/dashboard/alarm-notifications/notification-counts-graph/NotificationsCountsGraph";
import AlarmDashboardGraphContainer from "./AlarmDashboardGraphContainer";
import { AlarmDashboardViewOptions } from "../../components/dashboard/alarm-notifications/alarm-dashboard-view-options/AlarmDashboardViewOptions";
import { useMemo } from "react";
import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

export default function AlarmDashboardView() {

    const routeContext = useRouteContext();
    const { t } = useTranslation();

    const matches = useMediaQuery('(max-width:920px)');

    const {
        state,
        // setGroup,
        setDuration,
        setShowEmail,
        setShowText,
        setShowVoice,
        resetState
    } = useAlarmDashboardState();

    const groupID = state.groupID ?? routeContext.groupID as number;

    const {data: allowVoiceAlarmAttribute } = useQueryNotifications(useCustomerAttribute)({
        groupID: groupID,
        name: 'allow voice alarm',
    });

    const allowVoiceAlarm = allowVoiceAlarmAttribute?.attributeValue.toLowerCase() === 'true';

    const actionItems = useMemo(() => {
        return getActionMenuItems([BaseActionEnum.Favorite]);
    }, []);

    
    // function onGroupChanged(item: INavigationItem) {
    //     setGroup(item.objectID);
    // }

   return (
       <ContentView>
           <ContextualAppBar 
            //    hideBreadcrumb={false}
               actions={actionItems} 
               viewOptionState={state.viewOptionState}
            //    showGroupPicker={true}
            //    onGroupSelected={onGroupChanged}
               groupID={groupID}
           />
           <ContentContainer>
               <ContentSection>
                   <Paper sx={{
                               display: "flex",
                               flexDirection: "column",
                               flex: '1 1 auto',
                               overflow: "hidden",
                               overflowY: 'auto',
                               backgroundColor: "custom.background.cardContainer"
                           }}
                           elevation={0}
                       >

                           <Typography
                               variant='subtitle1'
                               sx={{
                                   margin: 1,
                                   textTransform: 'uppercase',
                                   fontWeight: 600
                               }}>
                               {t('alarmDashboard.title', { duration: state.durationLabel})}
                           </Typography>

                       <Stack
                           direction={matches ? 'column' : { sm: 'column', md: 'row' }}
                           spacing={{ xs: 1, sm: 2, md: 3 }}
                           sx={{
                               flex: '1 1 50%',
                               padding: 1
                           }}>
                               

                           <AlarmDashboardChartContainer>
                               <NotificationsCountChart 
                                   notificationsType={AlarmNotificationsType.Setpoints}
                                   groupID={groupID} 
                                   durationOptions={state.durationOptions}
                                   showEmail={state.showEmail}
                                   showText={state.showText}
                                   showVoice={state.showVoice && allowVoiceAlarm}
                               />
                           </AlarmDashboardChartContainer>

                           <AlarmDashboardChartContainer>

                               <NotificationsCountChart 
                                   notificationsType={AlarmNotificationsType.Objects}
                                   groupID={groupID} 
                                   durationOptions={state.durationOptions}
                                   showEmail={state.showEmail}
                                   showText={state.showText}
                                   showVoice={state.showVoice && allowVoiceAlarm}
                               />                                

                           </AlarmDashboardChartContainer>

                           <AlarmDashboardChartContainer>
                               <NotificationsCountChart 
                                   notificationsType={AlarmNotificationsType.Recipients}
                                   groupID={groupID} 
                                   durationOptions={state.durationOptions}                                    
                                   showEmail={state.showEmail}
                                   showText={state.showText}
                                   showVoice={state.showVoice && allowVoiceAlarm}
                               />
                           </AlarmDashboardChartContainer>

                       </Stack>

                       <Stack
                           direction='row'
                           sx={{
                               flex: '1 1 50%',

                               //minHeight: 300
                               padding: 1
                           }}>
                           <AlarmDashboardGraphContainer>
                               <NotificationsCountsGraph 
                                   groupID={groupID} 
                                   startDate={state.durationOptions.duration.startDate as Date}
                                   endDate={state.durationOptions.duration.endDate as Date}
                                   showEmail={state.showEmail}
                                   showText={state.showText}
                                   showVoice={state.showVoice && allowVoiceAlarm}
                               />
                           </AlarmDashboardGraphContainer>
                       </Stack>

                   </Paper>
               
               </ContentSection>

               <OptionsSideSheet onReset={resetState}>

                   <AlarmDashboardViewOptions groupID={groupID}
                       durationOptions={state.durationOptions} 
                       onDurationChanged={(values) => setDuration(values)}
                       showText={state.showText} 
                       onShowTextChanged={(checked) => setShowText(checked)}
                       showEmail={state.showEmail} 
                       onShowEmailChanged={(checked) => setShowEmail(checked)}
                       showVoice={state.showVoice} 
                       onShowVoiceChanged={(checked) => setShowVoice(checked)} />

               </OptionsSideSheet>

           </ContentContainer>
       </ContentView>
   );
  }
